import { inject, injectable } from 'tsyringe';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import { type ISupporterCompanyEditRepository } from 'application/repositorySchemas/ISupporterCompanyEditRepository';
import { type ISupporterEditCompanyProfileClient } from 'interfaceAdapter/gatewaySchemas/ISupporterEditCompanyProfileClient';

@injectable()
export class SupporterCompanyEditRepository implements ISupporterCompanyEditRepository {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ISupporterEditCompanyProfileClient')
        public readonly supporterEditCompanyProfileClient: ISupporterEditCompanyProfileClient,
    ) {}

    public async editProfile(company: any) {
        const { data, message } = await this.supporterEditCompanyProfileClient.post({
            token: this.supportUserToken.get() || '',
            company,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
